// Couleurs de FOND des pastilles de statut (toujours très claires : le texte garde sa couleur normale).
// Les statuts de business et d'avoir partagent certaines valeurs (CREATION, ABORTED) : une seule couleur par valeur.
// Pour un nouveau statut, ajouter simplement une ligne ici.
export const STATUS_BACKGROUND_COLOR = {
    // Business (devis / facture)
    CREATION: '#eceff1',        // gris
    READY_TO_SEND: '#fff3cd',   // jaune
    SENT: '#dbeafe',            // bleu
    ACCEPTED: '#dcfce7',        // vert
    IN_PROGRESS: '#ede9fe',     // violet
    DONE: '#ccfbf1',            // turquoise
    PAID: '#bbf7d0',            // vert soutenu
    PAID_AND_DECLARED: '#a7f3d0', // vert menthe
    REFUSED: '#fee2e2',         // rouge
    ABORTED: '#e5e7eb',         // gris soutenu
    // Client
    CONTACT: '#fef3c7',         // jaune
    QUALIFIED: '#ffedd5',       // orange
    INTERESTED: '#ffe4d6',      // saumon
    CONVERTED: '#dcfce7',       // vert
    UNINTERESTED: '#e5e7eb',    // gris
    // Avoir
    ISSUED: '#dbeafe',
    REFUNDED: '#bbf7d0',
    // Achat (PAID est déjà défini plus haut)
    TO_REVIEW: '#fff3cd',       // jaune
    TO_PAY: '#dbeafe',          // bleu
    PARTIALLY_PAID: '#ffedd5',  // orange
    // Livraison d'un achat
    NOT_RECEIVED: '#eceff1',        // gris
    PARTIALLY_RECEIVED: '#ffedd5',  // orange
    RECEIVED: '#dcfce7',            // vert
    // Marketing : sujet (SCHEDULED et PUBLISHED valent aussi pour une publication), texte (DRAFT), image
    IDEA: '#e0f2fe',                // bleu clair
    DRAFTING: '#ffedd5',            // orange
    READY: '#dcfce7',               // vert
    SCHEDULED: '#dbeafe',           // bleu
    PUBLISHED: '#bbf7d0',           // vert soutenu
    PARKED: '#e5e7eb',              // gris
    DRAFT: '#fff3cd',               // jaune
    FINAL: '#dcfce7',               // vert
    NONE: '#eceff1',                // gris
    TO_DO: '#ffedd5',               // orange
    GENERATED: '#dcfce7',           // vert
    VALIDATED: '#bbf7d0',           // vert soutenu
};

const DEFAULT_BACKGROUND_COLOR = '#f0f1f3';

export function getStatusBackgroundColor(status) {
    return STATUS_BACKGROUND_COLOR[status] || DEFAULT_BACKGROUND_COLOR;
}